const en = {
  'customizer.faq.previewQuestion': 'Can I preview a custom yo-yo before logging in?',
  'customizer.faq.previewAnswer': 'You can choose a label color first. Uploading artwork and adding the custom yo-yo to cart requires a customer account.',
  'customizer.faq.uploadQuestion': 'When do I upload the final artwork to YCH-YOYO?',
  'customizer.faq.uploadAnswer': 'Artwork is uploaded from the customizer before checkout so it can be attached to your paid order.',
  'customizer.faq.formatQuestion': 'What image format should I use?',
  'customizer.faq.formatAnswer': 'PNG, JPG, JPEG, and WebP are accepted for preview. A high-resolution transparent PNG is recommended for production artwork.',
  'customizer.faq.priceQuestion': 'What is the current custom yo-yo price?',
  'customizer.faq.priceAnswer': 'The current custom logo yo-yo is {{price}} per unit before shipping. Shipping is calculated during checkout.',
  'customizer.faq.positionQuestion': 'Can I adjust the logo position?',
  'customizer.faq.positionAnswer': 'Yes. You can move, scale, and rotate the artwork, and you can also move and resize the circular print area.',
  'customizer.faq.reviewQuestion': 'Do you review artwork before production?',
  'customizer.faq.reviewAnswer': 'Yes. After payment, YCH-YOYO manually checks the uploaded artwork and contacts you if production details need confirmation.',
  'customizer.error.readFile': 'Failed to read the artwork file.',
  'customizer.error.loadColors': 'Failed to load label colors.',
  'customizer.error.uploadArtwork': 'Artwork upload failed.',
  'customizer.error.uploadPreview': 'Preview upload failed.',
  'customizer.error.invalidType': 'Please upload a PNG, JPG, JPEG, or WebP image.',
  'customizer.error.tooLarge': 'Artwork file must be 5MB or smaller.',
  'customizer.error.chooseColor': 'Please choose a label color.',
  'customizer.error.uploadFirstTitle': 'Upload artwork first',
  'customizer.error.uploadFirstMessage': 'Please upload your artwork before adding this custom yo-yo to cart.',
  'customizer.error.uploading': 'Artwork is still uploading. Please wait a moment.',
  'customizer.error.uploadIncomplete': 'Artwork upload did not finish. Please choose the artwork file again.',
  'customizer.error.quantity': 'Quantity must be at least 1.',
  'customizer.error.generatePreview': 'Please generate a preview before adding to cart.',
  'customizer.error.addFailed': 'Failed to add custom yo-yo to cart.',
  'customizer.schemaDescription': 'Preview a custom logo yo-yo online, choose a label color, upload artwork, and add the custom yo-yo to cart.',
  'customizer.seoDescription': 'Preview your custom logo yo-yo online. Choose a private-label color, upload artwork, adjust the mockup, and add the custom yo-yo to cart.',
  'customizer.title': 'Custom Yo-Yo Builder',
  'customizer.heroEyebrow': 'YCH-YOYO Custom Service',
  'customizer.heroBody': 'Choose a label color, upload your logo or artwork, preview the custom yo-yo, and add it to your cart.',
  'customizer.start': 'Start Customizing',
  'customizer.progressAria': 'Customization progress',
  'customizer.progress.color': 'Color',
  'customizer.progress.artwork': 'Artwork',
  'customizer.progress.preview': 'Preview',
  'customizer.progress.cart': 'Cart',
  'customizer.step': 'Step {{number}}',
  'customizer.color.title': 'Choose a Label Color',
  'customizer.color.description': 'Select one private-label yo-yo color.',
  'customizer.color.loading': 'Loading label colors...',
  'customizer.color.groupsAria': 'Label color groups',
  'customizer.color.groupFallback': 'Colors',
  'customizer.color.selectedAlt': 'Selected label color',
  'customizer.color.selectedFallback': 'Label color',
  'customizer.color.chooseAria': 'Choose {{color}}',
  'customizer.artwork.title': 'Upload Artwork for Preview',
  'customizer.artwork.description': 'Log in first, then upload the artwork for preview and production review.',
  'customizer.artwork.chooseFile': 'Choose File',
  'customizer.artwork.noFile': 'No file selected',
  'customizer.artwork.fileHelp': 'PNG, JPG, JPEG, or WebP. Maximum 5MB.',
  'customizer.artwork.uploadedAlt': 'Uploaded artwork preview',
  'customizer.artwork.empty': 'Artwork',
  'customizer.artwork.uploading': 'Uploading artwork...',
  'customizer.artwork.uploaded': 'Artwork uploaded',
  'customizer.artwork.yours': 'Your artwork',
  'customizer.artwork.upload': 'Upload artwork',
  'customizer.preview.title': 'Preview Image',
  'customizer.preview.description': 'The ball image stays fixed. Move artwork or the circular print area.',
  'customizer.cart.title': 'Add Custom Yo-Yo to Cart',
  'customizer.cart.price': 'The custom logo yo-yo is currently {{price}} per unit before shipping.',
  'customizer.cart.quantity': 'Quantity',
  'customizer.cart.selectedColor': 'Selected label color',
  'customizer.cart.success': 'Custom Logo Yo-Yo added to cart. Your artwork and adjusted preview are attached to this cart item.',
  'customizer.cart.view': 'View cart',
  'customizer.cart.checking': 'Checking Account...',
  'customizer.cart.adding': 'Adding...',
  'customizer.help.title': 'Need help?',
  'customizer.help.wecom': 'Contact us on WeCom',
  'customizer.help.wechat': 'WeChat: {{account}}',
  'customizer.content.previewTitle': 'Why Preview Before Ordering?',
  'customizer.content.previewBody': 'See how your logo, team badge, event mark, or personal artwork may look on a YCH-YOYO private-label color before checkout.',
  'customizer.content.usesTitle': 'Custom Logo Yo-Yos for Teams, Clubs, Events, and Brands',
  'customizer.content.usesBody': 'Use the preview for team designs, school clubs, contest graphics, shop collaborations, brand gifts, and personalized yo-yos. Artwork and the adjusted preview are attached to the paid order for manual review.',
  'customizer.content.processTitle': 'How the Paid Custom Yo-Yo Process Works',
  'customizer.content.process1': 'Choose a private-label color and preview your artwork.',
  'customizer.content.process2': 'Add the custom logo yo-yo to cart at {{price}} per unit.',
  'customizer.content.process3': 'Log in, upload artwork, and adjust the preview.',
  'customizer.content.process4': 'Add the custom yo-yo to cart so the artwork is attached to the order.',
  'customizer.content.process5': 'YCH-YOYO reviews the artwork and follows up if production details need confirmation.',
  'customizer.content.guidelinesTitle': 'Artwork Guidelines',
  'customizer.content.guidelinesBody': 'Use the highest resolution artwork available. Transparent PNG files are best for clean logo edges. Keep important details away from the circular print edge because the final production file will be manually checked.',
  'customizer.faqTitle': 'Custom Yo-Yo FAQ',
  'customizer.login.title': 'Log in required',
  'customizer.login.message': 'Please log in or create an account before continuing with your custom yo-yo order.',
  'customizer.login.action': 'Login',
  'customizer.login.create': 'Create Account',
  'customizer.modal.ok': 'OK',
  'customizer.preview.loadModelError': 'The selected model image could not be loaded.',
  'customizer.preview.loadArtworkError': 'Artwork preview could not be loaded.',
  'customizer.preview.canvasAria': 'Custom yo-yo mockup preview',
  'customizer.preview.modeAria': 'Preview edit mode',
  'customizer.preview.moveArtwork': 'Move Artwork',
  'customizer.preview.movePrintArea': 'Move Print Area',
  'customizer.preview.scale': 'Scale',
  'customizer.preview.rotation': 'Rotation',
  'customizer.preview.printAreaSize': 'Print Area Size',
  'customizer.preview.resetArtwork': 'Reset Artwork',
  'customizer.preview.resetPrintArea': 'Reset Print Area',
  'customizer.preview.generate': 'Generate Preview',
};

const ja = {
  'customizer.faq.previewQuestion': 'ログイン前にカスタムヨーヨーをプレビューできますか？',
  'customizer.faq.previewAnswer': '最初にラベルカラーを選べます。アートワークのアップロードとカートへの追加にはアカウントが必要です。',
  'customizer.faq.uploadQuestion': '最終アートワークはいつアップロードしますか？',
  'customizer.faq.uploadAnswer': '決済前にカスタマイザーからアップロードし、支払い済み注文に添付します。',
  'customizer.faq.formatQuestion': 'どの画像形式を使えますか？',
  'customizer.faq.formatAnswer': 'プレビューにはPNG、JPG、JPEG、WebPを使用できます。製作用には高解像度の透過PNGを推奨します。',
  'customizer.faq.priceQuestion': '現在のカスタムヨーヨー価格はいくらですか？',
  'customizer.faq.priceAnswer': 'カスタムロゴヨーヨーは送料別で1個{{price}}です。送料は決済時に計算されます。',
  'customizer.faq.positionQuestion': 'ロゴの位置を調整できますか？',
  'customizer.faq.positionAnswer': 'はい。アートワークの移動、拡大縮小、回転と、円形印刷エリアの移動・サイズ変更ができます。',
  'customizer.faq.reviewQuestion': '製造前にアートワークを確認しますか？',
  'customizer.faq.reviewAnswer': 'はい。支払い後にYCH-YOYOが手動で確認し、製造条件の確認が必要な場合はご連絡します。',
  'customizer.error.readFile': 'アートワークファイルを読み込めませんでした。',
  'customizer.error.loadColors': 'ラベルカラーを読み込めませんでした。',
  'customizer.error.uploadArtwork': 'アートワークのアップロードに失敗しました。',
  'customizer.error.uploadPreview': 'プレビューのアップロードに失敗しました。',
  'customizer.error.invalidType': 'PNG、JPG、JPEG、WebP画像をアップロードしてください。',
  'customizer.error.tooLarge': 'アートワークは5MB以下にしてください。',
  'customizer.error.chooseColor': 'ラベルカラーを選択してください。',
  'customizer.error.uploadFirstTitle': '先にアートワークをアップロード',
  'customizer.error.uploadFirstMessage': 'カートに追加する前にアートワークをアップロードしてください。',
  'customizer.error.uploading': 'アートワークをアップロード中です。少々お待ちください。',
  'customizer.error.uploadIncomplete': 'アップロードが完了しませんでした。ファイルを選び直してください。',
  'customizer.error.quantity': '数量は1以上にしてください。',
  'customizer.error.generatePreview': 'カートに追加する前にプレビューを生成してください。',
  'customizer.error.addFailed': 'カスタムヨーヨーをカートに追加できませんでした。',
  'customizer.schemaDescription': 'ラベルカラーを選び、アートワークをアップロードして、カスタムロゴヨーヨーをオンラインでプレビューできます。',
  'customizer.seoDescription': 'カスタムロゴヨーヨーをオンラインでプレビュー。カラーを選び、アートワークを調整してカートに追加できます。',
  'customizer.title': 'カスタムヨーヨービルダー',
  'customizer.heroEyebrow': 'YCH-YOYO カスタムサービス',
  'customizer.heroBody': 'ラベルカラーを選び、ロゴやアートワークをアップロードして、カスタムヨーヨーをプレビューし、カートに追加できます。',
  'customizer.start': 'カスタマイズを始める',
  'customizer.progressAria': 'カスタマイズの進捗',
  'customizer.progress.color': 'カラー',
  'customizer.progress.artwork': 'アートワーク',
  'customizer.progress.preview': 'プレビュー',
  'customizer.progress.cart': 'カート',
  'customizer.step': 'ステップ{{number}}',
  'customizer.color.title': 'ラベルカラーを選ぶ',
  'customizer.color.description': 'プライベートラベル用カラーを1色選択してください。',
  'customizer.color.loading': 'カラーを読み込み中...',
  'customizer.color.groupsAria': 'ラベルカラーグループ',
  'customizer.color.groupFallback': 'カラー',
  'customizer.color.selectedAlt': '選択したラベルカラー',
  'customizer.color.selectedFallback': 'ラベルカラー',
  'customizer.color.chooseAria': '{{color}}を選択',
  'customizer.artwork.title': 'プレビュー用アートワークをアップロード',
  'customizer.artwork.description': 'ログイン後、プレビューと製造確認用のアートワークをアップロードしてください。',
  'customizer.artwork.chooseFile': 'ファイルを選択',
  'customizer.artwork.noFile': 'ファイル未選択',
  'customizer.artwork.fileHelp': 'PNG、JPG、JPEG、WebP。最大5MB。',
  'customizer.artwork.uploadedAlt': 'アップロードしたアートワークのプレビュー',
  'customizer.artwork.empty': 'アートワーク',
  'customizer.artwork.uploading': 'アップロード中...',
  'customizer.artwork.uploaded': 'アップロード済み',
  'customizer.artwork.yours': 'あなたのアートワーク',
  'customizer.artwork.upload': 'アートワークをアップロード',
  'customizer.preview.title': 'プレビュー画像',
  'customizer.preview.description': '本体画像は固定です。アートワークまたは円形印刷エリアを動かせます。',
  'customizer.cart.title': 'カスタムヨーヨーをカートに追加',
  'customizer.cart.price': 'カスタムロゴヨーヨーは現在、送料別で1個{{price}}です。',
  'customizer.cart.quantity': '数量',
  'customizer.cart.selectedColor': '選択したラベルカラー',
  'customizer.cart.success': 'カスタムロゴヨーヨーをカートに追加しました。アートワークと調整済みプレビューが添付されています。',
  'customizer.cart.view': 'カートを見る',
  'customizer.cart.checking': 'アカウントを確認中...',
  'customizer.cart.adding': '追加中...',
  'customizer.help.title': 'お困りですか？',
  'customizer.help.wecom': 'WeComで問い合わせる',
  'customizer.help.wechat': 'WeChat：{{account}}',
  'customizer.content.previewTitle': '注文前にプレビューする理由',
  'customizer.content.previewBody': '決済前に、ロゴ、チームバッジ、イベントマーク、個人作品がYCH-YOYOのカラー上でどう見えるか確認できます。',
  'customizer.content.usesTitle': 'チーム、クラブ、イベント、ブランド向けカスタムロゴヨーヨー',
  'customizer.content.usesBody': 'チーム、学校クラブ、大会、店舗コラボ、ブランドギフト、個人用デザインに利用できます。アートワークとプレビューは支払い済み注文に添付され、手動確認されます。',
  'customizer.content.processTitle': '有料カスタムヨーヨーの流れ',
  'customizer.content.process1': 'カラーを選び、アートワークをプレビューします。',
  'customizer.content.process2': '1個{{price}}でカートに追加します。',
  'customizer.content.process3': 'ログインしてアートワークをアップロードし、プレビューを調整します。',
  'customizer.content.process4': 'アートワークを注文に添付するため、カートに追加します。',
  'customizer.content.process5': 'YCH-YOYOが確認し、製造条件の確認が必要な場合はご連絡します。',
  'customizer.content.guidelinesTitle': 'アートワークガイドライン',
  'customizer.content.guidelinesBody': 'できるだけ高解像度の画像を使用してください。輪郭がきれいな透過PNGを推奨します。最終製造ファイルは手動確認するため、重要な部分を円形印刷エリアの端から離してください。',
  'customizer.faqTitle': 'カスタムヨーヨー FAQ',
  'customizer.login.title': 'ログインが必要です',
  'customizer.login.message': 'カスタムヨーヨーの注文を続けるには、ログインまたはアカウント登録をしてください。',
  'customizer.login.action': 'ログイン',
  'customizer.login.create': 'アカウント作成',
  'customizer.modal.ok': 'OK',
  'customizer.preview.loadModelError': '選択したモデル画像を読み込めませんでした。',
  'customizer.preview.loadArtworkError': 'アートワークのプレビューを読み込めませんでした。',
  'customizer.preview.canvasAria': 'カスタムヨーヨーのモックアッププレビュー',
  'customizer.preview.modeAria': 'プレビュー編集モード',
  'customizer.preview.moveArtwork': 'アートワークを移動',
  'customizer.preview.movePrintArea': '印刷エリアを移動',
  'customizer.preview.scale': '拡大縮小',
  'customizer.preview.rotation': '回転',
  'customizer.preview.printAreaSize': '印刷エリアサイズ',
  'customizer.preview.resetArtwork': 'アートワークをリセット',
  'customizer.preview.resetPrintArea': '印刷エリアをリセット',
  'customizer.preview.generate': 'プレビューを生成',
};

const zhCN = {
  'customizer.faq.previewQuestion': '登录前可以预览定制悠悠球吗？',
  'customizer.faq.previewAnswer': '你可以先选择标牌颜色。上传图稿和加入购物车需要客户账户。',
  'customizer.faq.uploadQuestion': '什么时候上传最终图稿？',
  'customizer.faq.uploadAnswer': '请在结账前从定制器上传图稿，以便附加到已付款订单。',
  'customizer.faq.formatQuestion': '应使用什么图片格式？',
  'customizer.faq.formatAnswer': '预览支持 PNG、JPG、JPEG 和 WebP。生产图稿建议使用高分辨率透明 PNG。',
  'customizer.faq.priceQuestion': '定制悠悠球目前多少钱？',
  'customizer.faq.priceAnswer': '定制标志悠悠球当前单价为 {{price}}，不含运费。运费将在结账时计算。',
  'customizer.faq.positionQuestion': '可以调整标志位置吗？',
  'customizer.faq.positionAnswer': '可以。你可以移动、缩放和旋转图稿，也可以移动并调整圆形印刷区域。',
  'customizer.faq.reviewQuestion': '生产前会审核图稿吗？',
  'customizer.faq.reviewAnswer': '会。付款后，YCH-YOYO 会人工检查上传的图稿，如需确认生产细节会与你联系。',
  'customizer.error.readFile': '无法读取图稿文件。',
  'customizer.error.loadColors': '无法加载标牌颜色。',
  'customizer.error.uploadArtwork': '图稿上传失败。',
  'customizer.error.uploadPreview': '预览图上传失败。',
  'customizer.error.invalidType': '请上传 PNG、JPG、JPEG 或 WebP 图片。',
  'customizer.error.tooLarge': '图稿文件不得超过 5MB。',
  'customizer.error.chooseColor': '请选择标牌颜色。',
  'customizer.error.uploadFirstTitle': '请先上传图稿',
  'customizer.error.uploadFirstMessage': '加入购物车前，请先上传图稿。',
  'customizer.error.uploading': '图稿仍在上传，请稍候。',
  'customizer.error.uploadIncomplete': '图稿未上传完成，请重新选择文件。',
  'customizer.error.quantity': '数量至少为 1。',
  'customizer.error.generatePreview': '加入购物车前，请先生成预览图。',
  'customizer.error.addFailed': '无法将定制悠悠球加入购物车。',
  'customizer.schemaDescription': '在线预览定制标志悠悠球，选择标牌颜色、上传图稿并加入购物车。',
  'customizer.seoDescription': '在线预览定制标志悠悠球。选择颜色、上传图稿、调整效果并加入购物车。',
  'customizer.title': '定制悠悠球生成器',
  'customizer.heroEyebrow': 'YCH-YOYO 定制服务',
  'customizer.heroBody': '选择标牌颜色，上传标志或图稿，预览定制悠悠球并加入购物车。',
  'customizer.start': '开始定制',
  'customizer.progressAria': '定制进度',
  'customizer.progress.color': '颜色',
  'customizer.progress.artwork': '图稿',
  'customizer.progress.preview': '预览',
  'customizer.progress.cart': '购物车',
  'customizer.step': '第 {{number}} 步',
  'customizer.color.title': '选择标牌颜色',
  'customizer.color.description': '请选择一种自有品牌悠悠球颜色。',
  'customizer.color.loading': '正在加载标牌颜色...',
  'customizer.color.groupsAria': '标牌颜色分组',
  'customizer.color.groupFallback': '颜色',
  'customizer.color.selectedAlt': '已选择的标牌颜色',
  'customizer.color.selectedFallback': '标牌颜色',
  'customizer.color.chooseAria': '选择 {{color}}',
  'customizer.artwork.title': '上传图稿并预览',
  'customizer.artwork.description': '请先登录，再上传用于预览和生产审核的图稿。',
  'customizer.artwork.chooseFile': '选择文件',
  'customizer.artwork.noFile': '未选择文件',
  'customizer.artwork.fileHelp': 'PNG、JPG、JPEG 或 WebP，最大 5MB。',
  'customizer.artwork.uploadedAlt': '已上传图稿预览',
  'customizer.artwork.empty': '图稿',
  'customizer.artwork.uploading': '正在上传图稿...',
  'customizer.artwork.uploaded': '图稿已上传',
  'customizer.artwork.yours': '你的图稿',
  'customizer.artwork.upload': '上传图稿',
  'customizer.preview.title': '预览图',
  'customizer.preview.description': '球体图片保持固定。移动图稿或圆形印刷区域。',
  'customizer.cart.title': '将定制悠悠球加入购物车',
  'customizer.cart.price': '定制标志悠悠球当前单价为 {{price}}，不含运费。',
  'customizer.cart.quantity': '数量',
  'customizer.cart.selectedColor': '已选标牌颜色',
  'customizer.cart.success': '定制标志悠悠球已加入购物车。图稿和调整后的预览已附加到该商品。',
  'customizer.cart.view': '查看购物车',
  'customizer.cart.checking': '正在检查账户...',
  'customizer.cart.adding': '正在添加...',
  'customizer.help.title': '需要帮助？',
  'customizer.help.wecom': '通过 WeCom 联系我们',
  'customizer.help.wechat': '微信：{{account}}',
  'customizer.content.previewTitle': '为什么下单前要预览？',
  'customizer.content.previewBody': '结账前即可查看标志、队徽、活动图案或个人作品在 YCH-YOYO 自有品牌颜色上的效果。',
  'customizer.content.usesTitle': '面向团队、社团、活动和品牌的定制标志悠悠球',
  'customizer.content.usesBody': '适用于团队设计、学校社团、比赛图案、商店联名、品牌礼品和个性化悠悠球。图稿和预览会附加到已付款订单并人工审核。',
  'customizer.content.processTitle': '付费定制悠悠球流程',
  'customizer.content.process1': '选择自有品牌颜色并预览图稿。',
  'customizer.content.process2': '以每个 {{price}} 的价格加入购物车。',
  'customizer.content.process3': '登录、上传图稿并调整预览。',
  'customizer.content.process4': '加入购物车，将图稿附加到订单。',
  'customizer.content.process5': 'YCH-YOYO 审核图稿，如需确认生产细节会与你联系。',
  'customizer.content.guidelinesTitle': '图稿指南',
  'customizer.content.guidelinesBody': '请使用尽可能高分辨率的图稿。透明 PNG 最适合保持标志边缘清晰。最终生产文件会人工检查，请让重要细节远离圆形印刷区域边缘。',
  'customizer.faqTitle': '定制悠悠球常见问题',
  'customizer.login.title': '需要登录',
  'customizer.login.message': '继续定制悠悠球订单前，请登录或创建账户。',
  'customizer.login.action': '登录',
  'customizer.login.create': '创建账户',
  'customizer.modal.ok': '确定',
  'customizer.preview.loadModelError': '无法加载所选模型图片。',
  'customizer.preview.loadArtworkError': '无法加载图稿预览。',
  'customizer.preview.canvasAria': '定制悠悠球效果预览',
  'customizer.preview.modeAria': '预览编辑模式',
  'customizer.preview.moveArtwork': '移动图稿',
  'customizer.preview.movePrintArea': '移动印刷区域',
  'customizer.preview.scale': '缩放',
  'customizer.preview.rotation': '旋转',
  'customizer.preview.printAreaSize': '印刷区域大小',
  'customizer.preview.resetArtwork': '重置图稿',
  'customizer.preview.resetPrintArea': '重置印刷区域',
  'customizer.preview.generate': '生成预览',
};

const zhTW = {
  ...zhCN,
  'customizer.faq.previewQuestion': '登入前可以預覽客製溜溜球嗎？',
  'customizer.faq.previewAnswer': '你可以先選擇標牌顏色。上傳圖稿和加入購物車需要客戶帳戶。',
  'customizer.faq.uploadQuestion': '什麼時候上傳最終圖稿？',
  'customizer.faq.uploadAnswer': '請在結帳前從客製工具上傳圖稿，以便附加到已付款訂單。',
  'customizer.faq.formatQuestion': '應使用什麼圖片格式？',
  'customizer.faq.formatAnswer': '預覽支援 PNG、JPG、JPEG 和 WebP。生產圖稿建議使用高解析度透明 PNG。',
  'customizer.faq.priceQuestion': '客製溜溜球目前多少錢？',
  'customizer.faq.priceAnswer': '客製標誌溜溜球目前單價為 {{price}}，不含運費。運費將在結帳時計算。',
  'customizer.faq.positionQuestion': '可以調整標誌位置嗎？',
  'customizer.faq.positionAnswer': '可以。你可以移動、縮放和旋轉圖稿，也可以移動並調整圓形印刷區域。',
  'customizer.faq.reviewQuestion': '生產前會審核圖稿嗎？',
  'customizer.faq.reviewAnswer': '會。付款後，YCH-YOYO 會人工檢查上傳的圖稿，如需確認生產細節會與你聯絡。',
  'customizer.error.readFile': '無法讀取圖稿檔案。',
  'customizer.error.loadColors': '無法載入標牌顏色。',
  'customizer.error.uploadArtwork': '圖稿上傳失敗。',
  'customizer.error.uploadPreview': '預覽圖上傳失敗。',
  'customizer.error.invalidType': '請上傳 PNG、JPG、JPEG 或 WebP 圖片。',
  'customizer.error.tooLarge': '圖稿檔案不得超過 5MB。',
  'customizer.error.chooseColor': '請選擇標牌顏色。',
  'customizer.error.uploadFirstTitle': '請先上傳圖稿',
  'customizer.error.uploadFirstMessage': '加入購物車前，請先上傳圖稿。',
  'customizer.error.uploading': '圖稿仍在上傳，請稍候。',
  'customizer.error.uploadIncomplete': '圖稿未上傳完成，請重新選擇檔案。',
  'customizer.error.quantity': '數量至少為 1。',
  'customizer.error.generatePreview': '加入購物車前，請先產生預覽圖。',
  'customizer.error.addFailed': '無法將客製溜溜球加入購物車。',
  'customizer.schemaDescription': '線上預覽客製標誌溜溜球，選擇標牌顏色、上傳圖稿並加入購物車。',
  'customizer.seoDescription': '線上預覽客製標誌溜溜球。選擇顏色、上傳圖稿、調整效果並加入購物車。',
  'customizer.title': '客製溜溜球產生器',
  'customizer.heroEyebrow': 'YCH-YOYO 客製服務',
  'customizer.heroBody': '選擇標牌顏色，上傳標誌或圖稿，預覽客製溜溜球並加入購物車。',
  'customizer.start': '開始客製',
  'customizer.progressAria': '客製進度',
  'customizer.progress.color': '顏色',
  'customizer.progress.artwork': '圖稿',
  'customizer.progress.preview': '預覽',
  'customizer.progress.cart': '購物車',
  'customizer.step': '第 {{number}} 步',
  'customizer.color.title': '選擇標牌顏色',
  'customizer.color.description': '請選擇一種自有品牌溜溜球顏色。',
  'customizer.color.loading': '正在載入標牌顏色...',
  'customizer.color.groupsAria': '標牌顏色分組',
  'customizer.color.groupFallback': '顏色',
  'customizer.color.selectedAlt': '已選擇的標牌顏色',
  'customizer.color.selectedFallback': '標牌顏色',
  'customizer.color.chooseAria': '選擇 {{color}}',
  'customizer.artwork.title': '上傳圖稿並預覽',
  'customizer.artwork.description': '請先登入，再上傳用於預覽和生產審核的圖稿。',
  'customizer.artwork.chooseFile': '選擇檔案',
  'customizer.artwork.noFile': '未選擇檔案',
  'customizer.artwork.fileHelp': 'PNG、JPG、JPEG 或 WebP，最大 5MB。',
  'customizer.artwork.uploadedAlt': '已上傳圖稿預覽',
  'customizer.artwork.empty': '圖稿',
  'customizer.artwork.uploading': '正在上傳圖稿...',
  'customizer.artwork.uploaded': '圖稿已上傳',
  'customizer.artwork.yours': '你的圖稿',
  'customizer.artwork.upload': '上傳圖稿',
  'customizer.preview.title': '預覽圖',
  'customizer.preview.description': '球體圖片保持固定。移動圖稿或圓形印刷區域。',
  'customizer.cart.title': '將客製溜溜球加入購物車',
  'customizer.cart.price': '客製標誌溜溜球目前單價為 {{price}}，不含運費。',
  'customizer.cart.quantity': '數量',
  'customizer.cart.selectedColor': '已選標牌顏色',
  'customizer.cart.success': '客製標誌溜溜球已加入購物車。圖稿和調整後的預覽已附加到該商品。',
  'customizer.cart.view': '查看購物車',
  'customizer.cart.checking': '正在檢查帳戶...',
  'customizer.cart.adding': '正在加入...',
  'customizer.help.title': '需要協助？',
  'customizer.help.wecom': '透過 WeCom 聯絡我們',
  'customizer.help.wechat': '微信：{{account}}',
  'customizer.content.previewTitle': '為什麼下單前要預覽？',
  'customizer.content.previewBody': '結帳前即可查看標誌、隊徽、活動圖案或個人作品在 YCH-YOYO 自有品牌顏色上的效果。',
  'customizer.content.usesTitle': '面向團隊、社團、活動和品牌的客製標誌溜溜球',
  'customizer.content.usesBody': '適用於團隊設計、學校社團、比賽圖案、商店聯名、品牌禮品和個人化溜溜球。圖稿和預覽會附加到已付款訂單並人工審核。',
  'customizer.content.processTitle': '付費客製溜溜球流程',
  'customizer.content.process1': '選擇自有品牌顏色並預覽圖稿。',
  'customizer.content.process2': '以每個 {{price}} 的價格加入購物車。',
  'customizer.content.process3': '登入、上傳圖稿並調整預覽。',
  'customizer.content.process4': '加入購物車，將圖稿附加到訂單。',
  'customizer.content.process5': 'YCH-YOYO 審核圖稿，如需確認生產細節會與你聯絡。',
  'customizer.content.guidelinesTitle': '圖稿指南',
  'customizer.content.guidelinesBody': '請使用盡可能高解析度的圖稿。透明 PNG 最適合保持標誌邊緣清晰。最終生產檔案會人工檢查，請讓重要細節遠離圓形印刷區域邊緣。',
  'customizer.faqTitle': '客製溜溜球常見問題',
  'customizer.login.title': '需要登入',
  'customizer.login.message': '繼續客製溜溜球訂單前，請登入或建立帳戶。',
  'customizer.login.action': '登入',
  'customizer.login.create': '建立帳戶',
  'customizer.modal.ok': '確定',
  'customizer.preview.loadModelError': '無法載入所選模型圖片。',
  'customizer.preview.loadArtworkError': '無法載入圖稿預覽。',
  'customizer.preview.canvasAria': '客製溜溜球效果預覽',
  'customizer.preview.modeAria': '預覽編輯模式',
  'customizer.preview.moveArtwork': '移動圖稿',
  'customizer.preview.movePrintArea': '移動印刷區域',
  'customizer.preview.scale': '縮放',
  'customizer.preview.rotation': '旋轉',
  'customizer.preview.printAreaSize': '印刷區域大小',
  'customizer.preview.resetArtwork': '重設圖稿',
  'customizer.preview.resetPrintArea': '重設印刷區域',
  'customizer.preview.generate': '產生預覽',
};

const fr = {
  ...en,
  'customizer.faq.previewQuestion': 'Puis-je prévisualiser un yo-yo personnalisé avant de me connecter ?',
  'customizer.faq.previewAnswer': "Vous pouvez d'abord choisir une couleur. Un compte client est requis pour importer un visuel et ajouter le yo-yo au panier.",
  'customizer.faq.uploadQuestion': 'Quand dois-je importer le visuel final ?',
  'customizer.faq.uploadAnswer': "Importez-le depuis l'outil avant le paiement afin qu'il soit joint à votre commande payée.",
  'customizer.faq.formatQuestion': "Quel format d'image utiliser ?",
  'customizer.faq.formatAnswer': 'PNG, JPG, JPEG et WebP sont acceptés. Un PNG transparent haute résolution est recommandé pour la production.',
  'customizer.faq.priceQuestion': 'Quel est le prix actuel du yo-yo personnalisé ?',
  'customizer.faq.priceAnswer': 'Le yo-yo avec logo personnalisé coûte actuellement {{price}} par unité, hors livraison. La livraison est calculée au paiement.',
  'customizer.faq.positionQuestion': 'Puis-je ajuster la position du logo ?',
  'customizer.faq.positionAnswer': "Oui. Vous pouvez déplacer, redimensionner et faire pivoter le visuel, ainsi que déplacer et redimensionner la zone d'impression circulaire.",
  'customizer.faq.reviewQuestion': 'Vérifiez-vous le visuel avant la production ?',
  'customizer.faq.reviewAnswer': 'Oui. Après paiement, YCH-YOYO contrôle manuellement le visuel et vous contacte si des détails doivent être confirmés.',
  'customizer.error.readFile': 'Impossible de lire le fichier du visuel.',
  'customizer.error.loadColors': 'Impossible de charger les couleurs.',
  'customizer.error.uploadArtwork': "Échec de l'importation du visuel.",
  'customizer.error.uploadPreview': "Échec de l'importation de l'aperçu.",
  'customizer.error.invalidType': 'Importez une image PNG, JPG, JPEG ou WebP.',
  'customizer.error.tooLarge': 'Le fichier doit faire 5 Mo ou moins.',
  'customizer.error.chooseColor': 'Choisissez une couleur.',
  'customizer.error.uploadFirstTitle': "Importez d'abord un visuel",
  'customizer.error.uploadFirstMessage': "Importez votre visuel avant d'ajouter ce yo-yo au panier.",
  'customizer.error.uploading': 'Le visuel est encore en cours de transfert. Patientez un instant.',
  'customizer.error.uploadIncomplete': "Le transfert n'est pas terminé. Sélectionnez de nouveau le fichier.",
  'customizer.error.quantity': 'La quantité doit être au moins de 1.',
  'customizer.error.generatePreview': "Générez un aperçu avant d'ajouter au panier.",
  'customizer.error.addFailed': "Impossible d'ajouter le yo-yo personnalisé au panier.",
  'customizer.schemaDescription': 'Prévisualisez un yo-yo avec logo personnalisé, choisissez une couleur, importez un visuel et ajoutez-le au panier.',
  'customizer.seoDescription': 'Prévisualisez votre yo-yo personnalisé en ligne. Choisissez une couleur, importez et ajustez le visuel, puis ajoutez-le au panier.',
  'customizer.title': 'Créateur de yo-yo personnalisé',
  'customizer.heroEyebrow': 'Service personnalisé YCH-YOYO',
  'customizer.heroBody': 'Choisissez une couleur, importez votre logo ou visuel, prévisualisez le yo-yo personnalisé et ajoutez-le au panier.',
  'customizer.start': 'Commencer la personnalisation',
  'customizer.progressAria': 'Progression de la personnalisation',
  'customizer.progress.color': 'Couleur',
  'customizer.progress.artwork': 'Visuel',
  'customizer.progress.preview': 'Aperçu',
  'customizer.progress.cart': 'Panier',
  'customizer.step': 'Étape {{number}}',
  'customizer.color.title': 'Choisir une couleur',
  'customizer.color.description': 'Sélectionnez une couleur de yo-yo en marque blanche.',
  'customizer.color.loading': 'Chargement des couleurs...',
  'customizer.color.groupsAria': 'Groupes de couleurs',
  'customizer.color.groupFallback': 'Couleurs',
  'customizer.color.selectedAlt': 'Couleur sélectionnée',
  'customizer.color.selectedFallback': 'Couleur',
  'customizer.color.chooseAria': 'Choisir {{color}}',
  'customizer.artwork.title': 'Importer un visuel pour aperçu',
  'customizer.artwork.description': "Connectez-vous, puis importez le visuel pour l'aperçu et la vérification de production.",
  'customizer.artwork.chooseFile': 'Choisir un fichier',
  'customizer.artwork.noFile': 'Aucun fichier sélectionné',
  'customizer.artwork.fileHelp': 'PNG, JPG, JPEG ou WebP. 5 Mo maximum.',
  'customizer.artwork.uploadedAlt': 'Aperçu du visuel importé',
  'customizer.artwork.empty': 'Visuel',
  'customizer.artwork.uploading': 'Importation du visuel...',
  'customizer.artwork.uploaded': 'Visuel importé',
  'customizer.artwork.yours': 'Votre visuel',
  'customizer.artwork.upload': 'Importer le visuel',
  'customizer.preview.title': 'Image d’aperçu',
  'customizer.preview.description': "L'image du yo-yo reste fixe. Déplacez le visuel ou la zone d'impression circulaire.",
  'customizer.cart.title': 'Ajouter le yo-yo personnalisé au panier',
  'customizer.cart.price': 'Le yo-yo avec logo personnalisé coûte actuellement {{price}} par unité, hors livraison.',
  'customizer.cart.quantity': 'Quantité',
  'customizer.cart.selectedColor': 'Couleur sélectionnée',
  'customizer.cart.success': 'Yo-yo avec logo personnalisé ajouté au panier. Le visuel et l’aperçu ajusté sont joints à cet article.',
  'customizer.cart.view': 'Voir le panier',
  'customizer.cart.checking': 'Vérification du compte...',
  'customizer.cart.adding': 'Ajout...',
  'customizer.help.title': "Besoin d'aide ?",
  'customizer.help.wecom': 'Nous contacter sur WeCom',
  'customizer.help.wechat': 'WeChat : {{account}}',
  'customizer.content.previewTitle': 'Pourquoi prévisualiser avant de commander ?',
  'customizer.content.previewBody': 'Voyez avant le paiement comment votre logo, écusson, motif ou création peut apparaître sur une couleur YCH-YOYO.',
  'customizer.content.usesTitle': 'Yo-yos personnalisés pour équipes, clubs, événements et marques',
  'customizer.content.usesBody': "Utilisez l'aperçu pour les équipes, clubs scolaires, concours, collaborations, cadeaux de marque et yo-yos personnalisés. Le visuel et l'aperçu sont joints à la commande payée pour contrôle manuel.",
  'customizer.content.processTitle': 'Fonctionnement de la commande personnalisée payante',
  'customizer.content.process1': 'Choisissez une couleur et prévisualisez votre visuel.',
  'customizer.content.process2': 'Ajoutez le yo-yo au panier à {{price}} par unité.',
  'customizer.content.process3': 'Connectez-vous, importez le visuel et ajustez l’aperçu.',
  'customizer.content.process4': 'Ajoutez le yo-yo au panier pour joindre le visuel à la commande.',
  'customizer.content.process5': 'YCH-YOYO contrôle le visuel et vous contacte si des détails doivent être confirmés.',
  'customizer.content.guidelinesTitle': 'Consignes pour le visuel',
  'customizer.content.guidelinesBody': "Utilisez la meilleure résolution disponible. Un PNG transparent donne des contours nets. Éloignez les détails importants du bord de la zone circulaire, car le fichier final sera vérifié manuellement.",
  'customizer.faqTitle': 'FAQ du yo-yo personnalisé',
  'customizer.login.title': 'Connexion requise',
  'customizer.login.message': 'Connectez-vous ou créez un compte pour poursuivre votre commande personnalisée.',
  'customizer.login.action': 'Se connecter',
  'customizer.login.create': 'Créer un compte',
  'customizer.modal.ok': 'OK',
  'customizer.preview.loadModelError': "Impossible de charger l'image du modèle sélectionné.",
  'customizer.preview.loadArtworkError': "Impossible de charger l'aperçu du visuel.",
  'customizer.preview.canvasAria': 'Aperçu de la maquette du yo-yo personnalisé',
  'customizer.preview.modeAria': "Mode d'édition de l'aperçu",
  'customizer.preview.moveArtwork': 'Déplacer le visuel',
  'customizer.preview.movePrintArea': "Déplacer la zone d'impression",
  'customizer.preview.scale': 'Échelle',
  'customizer.preview.rotation': 'Rotation',
  'customizer.preview.printAreaSize': "Taille de la zone d'impression",
  'customizer.preview.resetArtwork': 'Réinitialiser le visuel',
  'customizer.preview.resetPrintArea': "Réinitialiser la zone d'impression",
  'customizer.preview.generate': "Générer l'aperçu",
};

const es = {
  ...en,
  'customizer.faq.previewQuestion': '¿Puedo previsualizar un yo-yo personalizado antes de iniciar sesión?',
  'customizer.faq.previewAnswer': 'Puedes elegir primero un color. Necesitas una cuenta para subir el diseño y añadir el yo-yo al carrito.',
  'customizer.faq.uploadQuestion': '¿Cuándo subo el diseño final?',
  'customizer.faq.uploadAnswer': 'Súbelo desde el personalizador antes del pago para adjuntarlo a tu pedido pagado.',
  'customizer.faq.formatQuestion': '¿Qué formato de imagen debo usar?',
  'customizer.faq.formatAnswer': 'Se aceptan PNG, JPG, JPEG y WebP. Para producción se recomienda un PNG transparente de alta resolución.',
  'customizer.faq.priceQuestion': '¿Cuál es el precio actual del yo-yo personalizado?',
  'customizer.faq.priceAnswer': 'El yo-yo con logotipo personalizado cuesta {{price}} por unidad, sin envío. El envío se calcula al pagar.',
  'customizer.faq.positionQuestion': '¿Puedo ajustar la posición del logotipo?',
  'customizer.faq.positionAnswer': 'Sí. Puedes mover, escalar y girar el diseño, además de mover y cambiar el tamaño del área circular de impresión.',
  'customizer.faq.reviewQuestion': '¿Revisáis el diseño antes de producir?',
  'customizer.faq.reviewAnswer': 'Sí. Tras el pago, YCH-YOYO revisa el diseño y te contacta si hay que confirmar detalles de producción.',
  'customizer.error.readFile': 'No se pudo leer el archivo del diseño.',
  'customizer.error.loadColors': 'No se pudieron cargar los colores.',
  'customizer.error.uploadArtwork': 'No se pudo subir el diseño.',
  'customizer.error.uploadPreview': 'No se pudo subir la vista previa.',
  'customizer.error.invalidType': 'Sube una imagen PNG, JPG, JPEG o WebP.',
  'customizer.error.tooLarge': 'El archivo debe ocupar 5 MB o menos.',
  'customizer.error.chooseColor': 'Elige un color.',
  'customizer.error.uploadFirstTitle': 'Sube primero el diseño',
  'customizer.error.uploadFirstMessage': 'Sube tu diseño antes de añadir este yo-yo al carrito.',
  'customizer.error.uploading': 'El diseño todavía se está subiendo. Espera un momento.',
  'customizer.error.uploadIncomplete': 'La subida no terminó. Vuelve a seleccionar el archivo.',
  'customizer.error.quantity': 'La cantidad debe ser al menos 1.',
  'customizer.error.generatePreview': 'Genera una vista previa antes de añadir al carrito.',
  'customizer.error.addFailed': 'No se pudo añadir el yo-yo personalizado al carrito.',
  'customizer.schemaDescription': 'Previsualiza un yo-yo con logotipo personalizado, elige un color, sube el diseño y añádelo al carrito.',
  'customizer.seoDescription': 'Previsualiza tu yo-yo personalizado en línea. Elige un color, sube y ajusta el diseño y añádelo al carrito.',
  'customizer.title': 'Creador de yo-yos personalizados',
  'customizer.heroEyebrow': 'Servicio personalizado YCH-YOYO',
  'customizer.heroBody': 'Elige un color, sube tu logotipo o diseño, previsualiza el yo-yo personalizado y añádelo al carrito.',
  'customizer.start': 'Empezar a personalizar',
  'customizer.progressAria': 'Progreso de personalización',
  'customizer.progress.color': 'Color',
  'customizer.progress.artwork': 'Diseño',
  'customizer.progress.preview': 'Vista previa',
  'customizer.progress.cart': 'Carrito',
  'customizer.step': 'Paso {{number}}',
  'customizer.color.title': 'Elige un color',
  'customizer.color.description': 'Selecciona un color de yo-yo de marca privada.',
  'customizer.color.loading': 'Cargando colores...',
  'customizer.color.groupsAria': 'Grupos de colores',
  'customizer.color.groupFallback': 'Colores',
  'customizer.color.selectedAlt': 'Color seleccionado',
  'customizer.color.selectedFallback': 'Color',
  'customizer.color.chooseAria': 'Elegir {{color}}',
  'customizer.artwork.title': 'Sube el diseño para previsualizarlo',
  'customizer.artwork.description': 'Inicia sesión y sube el diseño para la vista previa y la revisión de producción.',
  'customizer.artwork.chooseFile': 'Elegir archivo',
  'customizer.artwork.noFile': 'Ningún archivo seleccionado',
  'customizer.artwork.fileHelp': 'PNG, JPG, JPEG o WebP. Máximo 5 MB.',
  'customizer.artwork.uploadedAlt': 'Vista previa del diseño subido',
  'customizer.artwork.empty': 'Diseño',
  'customizer.artwork.uploading': 'Subiendo diseño...',
  'customizer.artwork.uploaded': 'Diseño subido',
  'customizer.artwork.yours': 'Tu diseño',
  'customizer.artwork.upload': 'Subir diseño',
  'customizer.preview.title': 'Imagen de vista previa',
  'customizer.preview.description': 'La imagen del yo-yo permanece fija. Mueve el diseño o el área circular de impresión.',
  'customizer.cart.title': 'Añadir yo-yo personalizado al carrito',
  'customizer.cart.price': 'El yo-yo con logotipo personalizado cuesta {{price}} por unidad, sin envío.',
  'customizer.cart.quantity': 'Cantidad',
  'customizer.cart.selectedColor': 'Color seleccionado',
  'customizer.cart.success': 'Yo-yo con logotipo personalizado añadido. El diseño y la vista previa ajustada están adjuntos.',
  'customizer.cart.view': 'Ver carrito',
  'customizer.cart.checking': 'Comprobando cuenta...',
  'customizer.cart.adding': 'Añadiendo...',
  'customizer.help.title': '¿Necesitas ayuda?',
  'customizer.help.wecom': 'Contactar por WeCom',
  'customizer.help.wechat': 'WeChat: {{account}}',
  'customizer.content.previewTitle': '¿Por qué previsualizar antes de pedir?',
  'customizer.content.previewBody': 'Comprueba antes del pago cómo quedarán tu logotipo, emblema, gráfico o diseño en un color YCH-YOYO.',
  'customizer.content.usesTitle': 'Yo-yos personalizados para equipos, clubes, eventos y marcas',
  'customizer.content.usesBody': 'Usa la vista previa para equipos, clubes escolares, concursos, colaboraciones, regalos de marca y diseños personales. El diseño y la vista previa se adjuntan al pedido pagado para revisión manual.',
  'customizer.content.processTitle': 'Cómo funciona el pedido personalizado de pago',
  'customizer.content.process1': 'Elige un color y previsualiza tu diseño.',
  'customizer.content.process2': 'Añade el yo-yo al carrito por {{price}} la unidad.',
  'customizer.content.process3': 'Inicia sesión, sube el diseño y ajusta la vista previa.',
  'customizer.content.process4': 'Añade el yo-yo al carrito para adjuntar el diseño al pedido.',
  'customizer.content.process5': 'YCH-YOYO revisa el diseño y te contacta si hay que confirmar detalles.',
  'customizer.content.guidelinesTitle': 'Directrices del diseño',
  'customizer.content.guidelinesBody': 'Usa la mayor resolución disponible. Un PNG transparente ofrece bordes limpios. Mantén los detalles importantes alejados del borde circular porque el archivo final se revisará manualmente.',
  'customizer.faqTitle': 'Preguntas frecuentes sobre el yo-yo personalizado',
  'customizer.login.title': 'Inicio de sesión necesario',
  'customizer.login.message': 'Inicia sesión o crea una cuenta para continuar con tu pedido personalizado.',
  'customizer.login.action': 'Iniciar sesión',
  'customizer.login.create': 'Crear cuenta',
  'customizer.modal.ok': 'Aceptar',
  'customizer.preview.loadModelError': 'No se pudo cargar la imagen del modelo seleccionado.',
  'customizer.preview.loadArtworkError': 'No se pudo cargar la vista previa del diseño.',
  'customizer.preview.canvasAria': 'Vista previa del yo-yo personalizado',
  'customizer.preview.modeAria': 'Modo de edición de vista previa',
  'customizer.preview.moveArtwork': 'Mover diseño',
  'customizer.preview.movePrintArea': 'Mover área de impresión',
  'customizer.preview.scale': 'Escala',
  'customizer.preview.rotation': 'Rotación',
  'customizer.preview.printAreaSize': 'Tamaño del área de impresión',
  'customizer.preview.resetArtwork': 'Restablecer diseño',
  'customizer.preview.resetPrintArea': 'Restablecer área de impresión',
  'customizer.preview.generate': 'Generar vista previa',
};

const ko = {
  ...en,
  'customizer.faq.previewQuestion': '로그인 전에 커스텀 요요를 미리 볼 수 있나요?',
  'customizer.faq.previewAnswer': '먼저 라벨 색상을 선택할 수 있습니다. 아트워크 업로드와 장바구니 추가에는 고객 계정이 필요합니다.',
  'customizer.faq.uploadQuestion': '최종 아트워크는 언제 업로드하나요?',
  'customizer.faq.uploadAnswer': '결제 전에 커스터마이저에서 업로드하면 결제된 주문에 첨부됩니다.',
  'customizer.faq.formatQuestion': '어떤 이미지 형식을 사용해야 하나요?',
  'customizer.faq.formatAnswer': 'PNG, JPG, JPEG, WebP를 사용할 수 있습니다. 제작용으로는 고해상도 투명 PNG를 권장합니다.',
  'customizer.faq.priceQuestion': '현재 커스텀 요요 가격은 얼마인가요?',
  'customizer.faq.priceAnswer': '커스텀 로고 요요는 배송비 제외 개당 {{price}}입니다. 배송비는 결제 시 계산됩니다.',
  'customizer.faq.positionQuestion': '로고 위치를 조정할 수 있나요?',
  'customizer.faq.positionAnswer': '네. 아트워크를 이동, 확대·축소, 회전하고 원형 인쇄 영역도 이동하거나 크기를 바꿀 수 있습니다.',
  'customizer.faq.reviewQuestion': '제작 전에 아트워크를 검토하나요?',
  'customizer.faq.reviewAnswer': '네. 결제 후 YCH-YOYO가 아트워크를 수동 검토하고 제작 세부 확인이 필요하면 연락드립니다.',
  'customizer.error.readFile': '아트워크 파일을 읽을 수 없습니다.',
  'customizer.error.loadColors': '라벨 색상을 불러올 수 없습니다.',
  'customizer.error.uploadArtwork': '아트워크 업로드에 실패했습니다.',
  'customizer.error.uploadPreview': '미리보기 업로드에 실패했습니다.',
  'customizer.error.invalidType': 'PNG, JPG, JPEG 또는 WebP 이미지를 업로드하세요.',
  'customizer.error.tooLarge': '아트워크 파일은 5MB 이하여야 합니다.',
  'customizer.error.chooseColor': '라벨 색상을 선택하세요.',
  'customizer.error.uploadFirstTitle': '아트워크를 먼저 업로드하세요',
  'customizer.error.uploadFirstMessage': '장바구니에 담기 전에 아트워크를 업로드하세요.',
  'customizer.error.uploading': '아트워크를 업로드 중입니다. 잠시 기다려 주세요.',
  'customizer.error.uploadIncomplete': '업로드가 완료되지 않았습니다. 파일을 다시 선택하세요.',
  'customizer.error.quantity': '수량은 1개 이상이어야 합니다.',
  'customizer.error.generatePreview': '장바구니에 담기 전에 미리보기를 생성하세요.',
  'customizer.error.addFailed': '커스텀 요요를 장바구니에 담지 못했습니다.',
  'customizer.schemaDescription': '커스텀 로고 요요를 미리 보고 색상 선택, 아트워크 업로드 후 장바구니에 담으세요.',
  'customizer.seoDescription': '커스텀 로고 요요를 온라인에서 미리 보세요. 색상을 고르고 아트워크를 조정해 장바구니에 담을 수 있습니다.',
  'customizer.title': '커스텀 요요 빌더',
  'customizer.heroEyebrow': 'YCH-YOYO 커스텀 서비스',
  'customizer.heroBody': '라벨 색상을 고르고 로고나 아트워크를 업로드해 커스텀 요요를 미리 본 뒤 장바구니에 담으세요.',
  'customizer.start': '커스터마이징 시작',
  'customizer.progressAria': '커스터마이징 진행 상황',
  'customizer.progress.color': '색상',
  'customizer.progress.artwork': '아트워크',
  'customizer.progress.preview': '미리보기',
  'customizer.progress.cart': '장바구니',
  'customizer.step': '{{number}}단계',
  'customizer.color.title': '라벨 색상 선택',
  'customizer.color.description': '프라이빗 라벨 요요 색상 하나를 선택하세요.',
  'customizer.color.loading': '색상 불러오는 중...',
  'customizer.color.groupsAria': '라벨 색상 그룹',
  'customizer.color.groupFallback': '색상',
  'customizer.color.selectedAlt': '선택한 라벨 색상',
  'customizer.color.selectedFallback': '라벨 색상',
  'customizer.color.chooseAria': '{{color}} 선택',
  'customizer.artwork.title': '미리보기용 아트워크 업로드',
  'customizer.artwork.description': '먼저 로그인한 뒤 미리보기와 제작 검토용 아트워크를 업로드하세요.',
  'customizer.artwork.chooseFile': '파일 선택',
  'customizer.artwork.noFile': '선택한 파일 없음',
  'customizer.artwork.fileHelp': 'PNG, JPG, JPEG 또는 WebP. 최대 5MB.',
  'customizer.artwork.uploadedAlt': '업로드한 아트워크 미리보기',
  'customizer.artwork.empty': '아트워크',
  'customizer.artwork.uploading': '아트워크 업로드 중...',
  'customizer.artwork.uploaded': '아트워크 업로드 완료',
  'customizer.artwork.yours': '내 아트워크',
  'customizer.artwork.upload': '아트워크 업로드',
  'customizer.preview.title': '미리보기 이미지',
  'customizer.preview.description': '요요 이미지는 고정됩니다. 아트워크 또는 원형 인쇄 영역을 이동하세요.',
  'customizer.cart.title': '커스텀 요요 장바구니에 담기',
  'customizer.cart.price': '커스텀 로고 요요는 현재 배송비 제외 개당 {{price}}입니다.',
  'customizer.cart.quantity': '수량',
  'customizer.cart.selectedColor': '선택한 라벨 색상',
  'customizer.cart.success': '커스텀 로고 요요를 장바구니에 담았습니다. 아트워크와 조정된 미리보기가 첨부되었습니다.',
  'customizer.cart.view': '장바구니 보기',
  'customizer.cart.checking': '계정 확인 중...',
  'customizer.cart.adding': '추가 중...',
  'customizer.help.title': '도움이 필요하신가요?',
  'customizer.help.wecom': 'WeCom으로 문의',
  'customizer.help.wechat': 'WeChat: {{account}}',
  'customizer.content.previewTitle': '주문 전에 미리 보는 이유',
  'customizer.content.previewBody': '결제 전에 로고, 팀 배지, 이벤트 마크 또는 개인 작품이 YCH-YOYO 색상에서 어떻게 보이는지 확인하세요.',
  'customizer.content.usesTitle': '팀, 클럽, 이벤트와 브랜드를 위한 커스텀 로고 요요',
  'customizer.content.usesBody': '팀 디자인, 학교 동아리, 대회 그래픽, 매장 협업, 브랜드 선물과 개인 요요에 활용하세요. 아트워크와 미리보기는 결제된 주문에 첨부되어 수동 검토됩니다.',
  'customizer.content.processTitle': '유료 커스텀 요요 진행 과정',
  'customizer.content.process1': '색상을 고르고 아트워크를 미리 봅니다.',
  'customizer.content.process2': '개당 {{price}}로 장바구니에 담습니다.',
  'customizer.content.process3': '로그인하고 아트워크를 업로드한 뒤 미리보기를 조정합니다.',
  'customizer.content.process4': '아트워크가 주문에 첨부되도록 장바구니에 담습니다.',
  'customizer.content.process5': 'YCH-YOYO가 아트워크를 검토하고 제작 세부 확인이 필요하면 연락드립니다.',
  'customizer.content.guidelinesTitle': '아트워크 가이드라인',
  'customizer.content.guidelinesBody': '가능한 가장 높은 해상도를 사용하세요. 투명 PNG가 선명한 로고 가장자리에 적합합니다. 최종 제작 파일은 수동 검토되므로 중요한 부분을 원형 인쇄 가장자리에서 떨어뜨려 주세요.',
  'customizer.faqTitle': '커스텀 요요 FAQ',
  'customizer.login.title': '로그인이 필요합니다',
  'customizer.login.message': '커스텀 요요 주문을 계속하려면 로그인하거나 계정을 만드세요.',
  'customizer.login.action': '로그인',
  'customizer.login.create': '계정 만들기',
  'customizer.modal.ok': '확인',
  'customizer.preview.loadModelError': '선택한 모델 이미지를 불러올 수 없습니다.',
  'customizer.preview.loadArtworkError': '아트워크 미리보기를 불러올 수 없습니다.',
  'customizer.preview.canvasAria': '커스텀 요요 목업 미리보기',
  'customizer.preview.modeAria': '미리보기 편집 모드',
  'customizer.preview.moveArtwork': '아트워크 이동',
  'customizer.preview.movePrintArea': '인쇄 영역 이동',
  'customizer.preview.scale': '크기',
  'customizer.preview.rotation': '회전',
  'customizer.preview.printAreaSize': '인쇄 영역 크기',
  'customizer.preview.resetArtwork': '아트워크 초기화',
  'customizer.preview.resetPrintArea': '인쇄 영역 초기화',
  'customizer.preview.generate': '미리보기 생성',
};

export const customizerTranslations = { en, ja, 'zh-CN': zhCN, 'zh-TW': zhTW, fr, es, ko };
